<template>
  <div v-if="replyCount > 0" @click="stopEventBubbling($event)">
    <div class="reply-line"></div>
    <v-col
      cols="auto"
      class="ml-5 pa-0"
      v-bind:key="reply.cmId"
      v-for="reply in replyList"
      style="border-top: 1px solid rgba(255, 255, 255, 0.05)"
    >
      <v-row no-gutters class="wrap-reply d-flex flex-nowrap mt-2">
        <v-col cols="auto" style="width: 10px"></v-col>
        <v-col style="width: 35px" cols="auto" align="center">
          <v-avatar
            :color="!reply.userPicture ? reply.userDisplayName || currentUser.userFullName : '' | iconBackground"
            class="logo"
            round
            size="35"
            style="cursor: default"
          >
            <div class="avatar-bg" v-if="reply.userPicture"></div>
            <span class="white--text cent" style="font-size: 14px" v-if="reply.userPicture === ''">
              {{ reply.userDisplayName || currentUser.userFullName | iconFilter }}
            </span>
            <v-img :src="reply.userPicture" v-else />
          </v-avatar>
        </v-col>
        <v-col class="pl-2">
          <v-row no-gutters align="center">
            <v-col cols="auto">
              <div style="display: block">
                <h5 style="color: white">{{ reply.userDisplayName || currentUser.userFullName }}</h5>
              </div>
              <div style="display: block; margin-top: -7px">
                <span style="color: #96a7af; font-size: 11px">
                  {{ $day.duration($day().diff(reply.cmCreatedAt)).humanize().replace('a day', 'Yesterday') }}
                </span>
              </div>
            </v-col>

            <v-col class="d-flex" style="justify-content: end">
              <div v-show="reply.commentMenu" no-gutters align="end" class="dot-comment flex-column">
                <v-menu v-model="reply.commentMenu" offset-y>
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn plain v-bind="attrs" v-on="on" style="min-width: 36px">
                      <span
                        :style="
                          $vuetify.breakpoint.width < 960
                            ? 'font-size: 16px; font-weight: 500'
                            : 'font-size: 16px; font-weight: 500'
                        "
                        class="material-icons-round white--text"
                        translate="no"
                      >
                        {{ reply.commentMenu ? 'close' : 'more_horiz' }}
                      </span>
                    </v-btn>
                  </template>
                  <div class="container-menu-comment" style="background-color: #1d292f; overflow: hidden">
                    <v-row align="center" justify="center" dense>
                      <v-col cols="12">
                        <v-btn dark block class="" color="#eee" plain @click.stop="replyMode(reply)">
                          <span
                            class="material-icons-round mr-1"
                            style="color: #ddd; font-size: 18px; font-weight: 400"
                          >
                            reply
                          </span>
                          Reply
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <v-btn
                          dark
                          block
                          class=""
                          color="#eee"
                          plain
                          @click.stop="editMode(reply.cmId, reply)"
                          v-if="
                            currentUser.userId && currentUser.userId !== null && currentUser.userId === reply.userId
                          "
                        >
                          <span
                            class="material-icons-round mr-1"
                            style="color: #ddd; font-size: 18px; font-weight: 400"
                          >
                            edit
                          </span>
                          Edit
                        </v-btn>
                      </v-col>
                      <v-col cols="12" style="padding: 0 !important">
                        <v-divider dark style="display: block"></v-divider>
                      </v-col>
                      <v-col cols="12">
                        <v-btn
                          dark
                          block
                          class=""
                          color="#eee"
                          plain
                          @click.stop="deleteC(reply.cmId, reply)"
                          v-if="isMtOrganizer || isWsOwner || isWsManager || currentUser.userId === reply.userId"
                        >
                          <span
                            class="material-icons-round mr-1"
                            style="color: #ddd; font-size: 18px; font-weight: 400"
                          >
                            delete
                          </span>
                          Delete
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-menu>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="textarea-col py-2">
              <v-textarea
                :id="reply.cmId"
                v-if="!isReply && targetId === reply.cmId"
                class="pa-0 mt-2"
                :background-color="'#475E69'"
                dense
                dark
                outlined
                auto-grow
                hide-details
                v-model="reply.cmContent"
                :value="reply.cmContent | commentFilter(reply.cmId) | removeHtmlFilter"
              ></v-textarea>
              <detail-html
                v-show="isReply || targetId !== reply.cmId"
                :cmContent.sync="reply.cmContent"
                :cmId="reply.cmId"
              ></detail-html>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="d-flex flex-nowrap" no-gutters>
        <v-col
          cols="12"
          class="d-flex container-btn-edit"
          v-if="isEdit && targetId === reply.cmId"
          style="justify-content: end"
        >
          <v-btn text color="#ccc" dark class="cancel_btn px-2" elevation="0" @click.stop="cancel()">
            <span
              class="material-icons-round mr-1"
              style="color: #bbb; font-size: 18px; font-weight: 400"
              translate="no"
            >
              highlight_off
            </span>
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            text
            dark
            color="#ccc"
            class="ml-1 save_btn"
            :loading="isSaveEditLoading"
            @click.stop="saveReply(reply)"
          >
            <span
              class="material-icons-round mr-1"
              style="color: #bbb; font-size: 18px; font-weight: 400"
              translate="no"
            >
              check_circle_outline
            </span>
            {{ $t('save') }}
          </v-btn>
        </v-col>
        <!-- <v-col v-else cols="auto" class="comment_btn_col">
          <v-btn dark class="pl-0 pr-2" color="#00ff98" plain @click.stop="replyMode(reply)">Reply</v-btn>
          <v-btn
            v-if="currentUser.userId && currentUser.userId !== null && currentUser.userId === reply.userId"
            dark
            class="px-2 ml-1"
            plain
            @click.stop="editMode(reply.cmId)"
          >
            Edit
          </v-btn>
          <v-btn
            v-if="isMtOrganizer || isWsOwner || isWsManager || currentUser.userId === reply.userId"
            dark
            class="px-2 ml-1"
            color="#FF575F"
            plain
            @click.stop="deleteC(reply.cmId)"
          >
            Delete
          </v-btn>
        </v-col> -->
      </v-row>
      <div v-if="isReply && targetId === reply.cmId" class="mt-3">
        <v-row no-gutters>
          <v-col cols="auto" style="width: 15px"></v-col>
          <v-col class="textarea-col">
            <v-textarea
              @keydown.enter="onEnterPress($event, replyComment, saveReply)"
              prepend-icon="mdi-arrow-right-bottom"
              ref="txta_reply"
              class="pa-0"
              background-color="#475E69"
              solo
              color="#96a7af"
              dense
              dark
              flat
              rows="1"
              hide-details
              auto-grow
              v-model="replyComment.cmContent"
              style="font-size: 14px"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="space-between" no-gutters class="container-btn-reply d-flex flex-nowrap mt-2">
          <v-spacer style="max-width: 80px" />
          <!-- <v-col cols="auto" style="align-self: center">
            <a class="a-timestamp" @click="setTimeStamp(replyComment, true)">
              {{ 'Add a timestamp' }}
              <v-icon color="#96a7af" class="btn-icon mr-2 pointer">mdi-clipboard-text-clock</v-icon>
            </a>
          </v-col> -->
          <v-spacer />
          <v-col cols="auto">
            <v-btn
              text
              color="#ccc"
              dark
              class="px-2 cancel_btn"
              style="background-color: transparent"
              elevation="0"
              @click.stop="cancel()"
            >
              <span
                class="material-icons-round mr-1"
                style="color: #bbb; font-size: 18px; font-weight: 400"
                translate="no"
              >
                highlight_off
              </span>
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              text
              color="#ccc"
              dark
              elevation="0"
              :loading="isSaveReplyLoading"
              @click.stop="postComment(replyComment)"
            >
              <span
                class="material-icons-round mr-1"
                style="color: #bbb; font-size: 18px; font-weight: 400"
                translate="no"
              >
                check_circle_outline
              </span>
              {{ $t('post') }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-col>
    <confirm-modal
      :title="$t('deleteComment')"
      ref="confirm"
      :isVisible.sync="isVisible"
      :message="$t('cannotUndoneMsg')"
      :cancelLabel="$t('cancel')"
      :confirmLabel="$t('confirm')"
    ></confirm-modal>
    <guest-in v-if="guestInVisible" @close="closeGuestIn" :guestInVisible.sync="guestInVisible"></guest-in>
  </div>
</template>

<script>
import {
  getCommentList,
  getPublicCommentList,
  createComment,
  deleteComment,
  updateComment,
} from '@/services/commentApi'
import Toast from '@/views/meeting/component/Toast'
import ConfirmModal from '@/views/modal/ConfirmModal'
import DetailHtml from '@/views/meeting/component/detail/DetailHtml'
import { numFormat, time } from '@/common/lib/strLib'
import { sendDataWithEnter } from '@/common/common'
import { mapGetters } from 'vuex'
import { isMobile } from '@/common/lib/strLib'
import GuestIn from '@/views/modal/GuestIn'

export default {
  name: 'DetailReply',
  components: { DetailHtml, ConfirmModal, GuestIn },
  props: {
    replyCount: Number,
    parentId: String,
  },
  created() {
    this.getReply()
  },
  data() {
    return {
      replyList: [],
      idList: [],
      isReply: false,
      isEdit: false,
      targetId: '',
      isVisible: false,
      replyComment: {
        cmContent: '',
        cmId: '',
      },
      isSaveReplyLoading: false,
      isSaveEditLoading: false,
      guestInActionType: '',
      guestInVisible: false,
      replyParentData: '',
    }
  },
  methods: {
    stopEventBubbling(e) {
      if (this.isMobile) {
        e.stopPropagation()
      } else return
    },

    closeGuestIn() {
      this.guestInVisible = false
      if (this.currentUser && !isEmptyObject(this.currentUser)) {
        this.postComment(this.guestInActionType)
      }
      function isEmptyObject(param) {
        return Object.keys(param).length === 0 && param.constructor === Object
      }
    },

    postComment(comment) {
      if (
        this.chkMtPublic &&
        this.chkMtPublic['isPublic'] &&
        (!this.currentUser.userId || this.currentUser.userId === null)
      ) {
        this.guestInActionType = comment
        this.guestInVisible = true
      } else {
        this.saveReply(comment)
      }
    },

    onEnterPress(e, comment) {
      if (this.isPostingComment) return
      if (e.which === 13 && !e.shiftKey) {
        e.preventDefault()
        if (
          this.chkMtPublic &&
          this.chkMtPublic['isPublic'] &&
          (!this.currentUser.userId || this.currentUser.userId === null)
        ) {
          this.postComment(comment)
        } else {
          this.saveReply(comment)
        }
      }
    },

    // postCommentWithEnter(e, replyComment) {
    //   if (e.key === 'Enter' && !e.shiftKey) {
    //     e.preventDefault()
    //     this.saveReply(replyComment)
    //   }
    // },

    handleInputEnter(e, args, callbackFnc) {
      sendDataWithEnter(e, args, callbackFnc)
    },

    async getReply() {
      let result =
        this.chkMtPublic && this.chkMtPublic['isPublic']
          ? await getPublicCommentList(this, this.currentMt.mtId, this.currentClip.clipId, this.parentId, undefined)
          : await getCommentList(this, this.currentMt.mtId, this.currentClip.clipId, this.parentId, undefined)
      if (result && result !== null) this.replyList = result.list
    },
    editMode(id, reply) {
      this.targetId = id
      this.isEdit = true
      this.isReply = false
      reply.commentMenu = false
    },
    replyMode(reply) {
      this.replyParentData = reply.boxData.time
      this.targetId = reply.cmId
      this.isReply = true
      this.isEdit = false
      this.replyComment = { cmContent: '', cmId: '' }
      reply.commentMenu = false
    },
    cancel() {
      this.targetId = ''
      this.isReply = false
      this.isEdit = false
      this.replyComment = { cmContent: '', cmId: '' }
    },
    async setTimeStamp(comment, isReply) {
      let textArea = isReply
        ? this.$refs.txta_reply[0].$el.querySelector('textarea')
        : this.$refs.txta_comment.$el.querySelector('textarea')
      let cursorStart = textArea.selectionStart
      let startTxt = comment.cmContent.substring(0, cursorStart)
      let endTxt = comment.cmContent.substring(cursorStart, comment.cmContent.length)

      let sectionContents = this.currentMt.mtType === 'topic' ? numFormat(Number(this.sectionIndex) + 1) + '-' : ''

      comment.cmContent =
        startTxt +
        '[Clip#' +
        sectionContents +
        numFormat(
          this.currentMt.mtType === 'chronological' ? Number(this.sectionIndex) + 1 : Number(this.clipIndex) + 1
        ) +
        ' ' +
        time(this.seekTime) +
        ']' +
        endTxt
    },
    async saveReply(comment) {
      if (this.isReply) {
        if (this.replyComment.cmContent === '') {
          // notify(this, 'Error', 'Content is Empty', 'error')
          const content = {
            component: Toast,
            props: {
              msg: 'Content is Empty',
              // submsg: '',
            },
          }
          this.$toast.error(content)
          return
        }
        this.isSaveReplyLoading = true
        await this.doSave(comment)
      } else if (this.isEdit) {
        if (comment.cmContent === '') {
          // notify(this, 'Error', 'Content is Empty', 'error')
          const content = {
            component: Toast,
            props: {
              msg: 'Content is Empty',
              // submsg: '',
            },
          }
          this.$toast.error(content)
          return
        }
        comment.cmContent = document.getElementById(comment.cmId).value
        this.isSaveEditLoading = true
        await this.doSave(comment)
      } else {
        if (this.comment.cmContent === '') {
          // notify(this, 'Error', 'Content is Empty', 'error')
          const content = {
            component: Toast,
            props: {
              msg: 'Content is Empty',
              // submsg: '',
            },
          }
          this.$toast.error(content)
          return
        }
        await this.doSave(this.comment)
      }
      // if (this.isReply) {
      //   if (this.replyComment.cmContent === '') {
      //     notify(this, 'Error', 'Content is Empty', 'error')
      //     return
      //   }
      //   this.isSaveReplyLoading = true
      //   await this.doSave(this.replyComment)
      // } else if (this.isEdit) {
      //   if (comment.cmContent === '') {
      //     notify(this, 'Error', 'Content is Empty', 'error')
      //     return
      //   }
      //   comment.cmContent = document.getElementById(comment.cmId).value
      //   this.isSaveEditLoading = true
      //   await this.doSave(comment)
      // } else {
      //   if (this.comment.cmContent === '') {
      //     notify(this, 'Error', 'Content is Empty', 'error')
      //     return
      //   }
      //   await this.doSave(this.comment)
      // }
    },
    async doSave(comment) {
      let timestamp

      let stampInfo

      if (this.currentMt.mtType === 'topic') {
        timestamp = comment.cmContent.match(/\[Clip#\d{2}-\d{2}\s\d{2}:\d{2}]/g)
      } else {
        timestamp = comment.cmContent.match(/\[Clip#\d{2}\s\d{2}:\d{2}]/g)
      }
      let content = comment.cmContent
      for (let i in timestamp) {
        try {
          if (this.currentMt.mtType === 'topic')
            stampInfo = timestamp[i]
              .replace('-', ' ')
              .replace(/[^0-9.\s\\:]/g, '')
              .split(' ')
          else stampInfo = timestamp[i].replace(/[^0-9.\s\\:]/g, '').split(' ')

          let stId
          let clipId

          if (this.currentMt.mtType === 'topic') {
            stId = this.totalSectionList[Number(stampInfo[0]) - 1].stId
            clipId = this.totalSectionList[Number(stampInfo[0]) - 1].clipList[Number(stampInfo[1] - 1)].clipId
            content = content.replaceAll('Clip#' + stampInfo[0], 'stId:' + stId)
            content = content.replaceAll('-' + stampInfo[1], ' clipId:' + clipId)
          } else {
            if (this.currentMt.mtType === 'chronological') {
              clipId = this.totalSectionList[Number(stampInfo[0]) - 1].clipList[0].clipId
            } else {
              clipId = this.totalSectionList[0].clipList[Number(stampInfo[0]) - 1].clipId
            }
            content = content.replaceAll('Clip#' + stampInfo[0], 'clipId:' + clipId)
          }
        } catch (e) {
          console.log(e)
        }
      }
      try {
        if (this.isEdit) {
          await updateComment(this, this.currentMt.mtId, comment.cmId, content, comment.cmContent)
        } else {
          let time

          if (this.isReply) {
            time = this.replyParentData
          }

          let boxData
          if (this.boxCommentComponent) {
            boxData =
              this.boxCommentComponent.getBoxData(time) &&
              this.boxCommentComponent.getBoxData(time) !== undefined &&
              this.boxCommentComponent.getBoxData(time) !== null
                ? this.boxCommentComponent.getBoxData(time)
                : this.boxCommentComponent.getTimeOnlyCommentData(this.isReply, this.replyParentData)
          }

          await createComment(
            this,
            this.currentMt.mtId,
            this.currentClip.clipId,
            this.parentId,
            content,
            comment.cmContent,
            boxData
          )
        }

        this.$store.dispatch('setFirebaseLog', {
          eventName: 'create_comment',
          eventParam: {
            name: 'create_comment',
          },
        })
        // Inbox 채널일 경우 클립 생성 로그 추가
        if (this.selectedCh && this.selectedCh['chCategory'] === 'inbox') {
          this.$store.dispatch('setFirebaseLog', {
            eventName: 'inbox_create_comment',
            eventParam: {
              name: 'inbox_create_comment',
            },
          })
        }

        this.cancel()
      } catch (e) {
        console.log(e)
      } finally {
        await this.getReply()
        this.isSaveEditLoading = false
        this.isSaveReplyLoading = false
      }
    },
    async deleteC(id, reply) {
      this.isVisible = true
      reply.commentMenu = false
      this.$refs.confirm
        .show()
        .then(() => {
          this.doDelete(id)
        })
        .catch(() => {
          // alert('You rejected')
        })
    },
    async doDelete(id) {
      try {
        await deleteComment(this, this.currentMt.mtId, id)
      } catch (e) {
        console.log(e)
      } finally {
        // notify(this, 'Success', 'Delete success', 'success')
        this.isVisible = false
        this.$refs.confirm.updateVisible(false)
        await this.getReply()
      }
    },
  },
  computed: {
    ...mapGetters([
      'currentMt',
      'isMtOrganizer',
      'isWsOwner',
      'isWsManager',
      'clipList',
      'clipIndex',
      'sectionIndex',
      'currentClip',
      'seekTime',
      'totalSectionList',
      'chkMtPublic',
      'selectedCh',
    ]),
    currentUser() {
      let user = this.$store.getters.userInfo
      return user && user !== null ? user : {}
    },

    isMobile() {
      return isMobile()
      // return true
    },
    boxCommentComponent() {
      return this.$root.$refs[`BoxComment-${this.sectionIndex}`]
    },
  },
  watch: {
    replyCount() {
      this.getReply()
    },
  },
}
</script>

<style scoped>
.crown {
  color: #ffc542;
  font-size: 15px;
  position: relative;
  transform: translate(0px, -45px);
}

.v-avatar {
  border: 2px solid #30444e !important;
}

.comment_btn {
  background-color: transparent !important;
  font-size: 12px;
  padding-left: 0;
  padding-right: 0;
  width: 50px !important;
}

.save_btn {
  font-size: 12px;
  height: 30px;
}

.cancel_btn {
  background-color: transparent !important;
  font-size: 12px;
  height: 30px;
}

.comment_btn_col >>> .v-btn:not(.v-btn--round).v-size--default {
  min-width: 50px !important;
}

.v-text-field--outlined >>> fieldset {
  border-color: transparent;
}

.textarea-col >>> .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  padding-left: 5px;
}

.textarea-col >>> .v-text-field__slot textarea {
  color: #ffffff !important;
  line-height: 25px !important;
}

.a-timestamp {
  font-size: 14px;
  word-break: normal;
}

.textarea-col >>> textarea {
  padding-left: 5px !important;
}

.textarea-col >>> .v-input {
  font-size: 13px;
}

.textarea-col >>> i {
  font-size: 17px;
  color: #999;
}
.reply-line {
  position: absolute;
  bottom: 20px;
  left: 28px;
  width: 1px;
  height: calc(100% - 85px);
  /* background-color: rgba(31, 46, 53, 0.66); */
}
.avatar-bg {
  content: '';
  position: absolute;
  border-radius: 50%;
  top: 0px;
  left: 0px;
  width: calc(100%) !important;
  height: calc(100%) !important;
  background-color: white;
  z-index: 0;
}
.container-menu-comment {
  width: 200px;
  padding: 4px;
  border-radius: 5px;
  border: 1px solid #475e69;
}
.container-menu-comment >>> .row--dense > .col {
  padding: 4px !important;
}
/* .container-menu-comment >>> .row--dense > .col {
  padding: 0 !important;
} */
.container-menu-comment >>> button span {
  font-size: 13px;
  font-weight: 400;
}

.container-menu-comment >>> button {
  width: 192px;
  justify-content: start;
}
.container-menu-comment >>> button:hover {
  /* border: 1px solid #666; */
  background-color: #161d21;
}
.container-btn-edit >>> button span,
.container-btn-reply >>> button span {
  font-size: 12px;
  font-weight: 400;
}
.wrap-reply:hover .dot-comment {
  display: inline-flex !important;
}
</style>
